import React, { useState } from "react";
import { usePartsData } from "../../hooks/usePartsData";
import { Form } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Box } from "react-bulma-components";
import { Table } from "react-bulma-components";
import {useDispatch, useSelector} from "react-redux";
import {
  getDataFresh,
  getPartLookupData,
  getPartsData,
  getVehicleMakeData, getVehicleModelData,
  getVehicleTypesData
} from "../../state/selectors";
import { Pagination } from "react-bulma-components";
import PartLookupRow from "./PartLookupRow";
import useSelect from "../../hooks/useSelect";
import {
  createSetDataFreshAction,
  createSetPartLookupDataAction,
  createSetPartsDataAction,
  createSetWorkDataAction
} from "../../actions/dataActions";
import {usePartLookupData} from "../../hooks/usePartLookupData";
import CreatePartModal from "./CreatePartModal";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import {useVehicleTypeData} from "../../hooks/useVehicleTypeData";
import axios from "axios";
import MultiplePartStockEditModal from "./MultiplePartStockEditModal";
import FAIcon from "../Icon/FAIcon";
import {useVehicleModelData} from "../../hooks/useVehicleModelData";
import {useVehicleMakeData} from "../../hooks/useVehicleMakeData";
import SearchBar from "../Utils/SearchBar";

function PartLookup(props) {
  const [searchText, setSearchText] = useState("");
  const [selected, setSelected] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(1);
  const dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();
  const vehicle_types_loaded = useVehicleTypeData({page_size:50});

  const [createPartModalOpen, setCreatePartModalOpen] = useState(false);

  const headings = [
    {
      label: "Make",
      field: "make",
      labelField: "make__name"
    },
    { label: "Model",
      field: "model",
      labelField: "model__name"
    },
    {
      label: "Variant"
    },
    {
      label: "Type",
      field: 'vehicle_type',
      labelField: "vehicle_type__name"
    },

    {
      label: "Part Name",
      field: "name",
      labelField: "name"
    },
    {
      label: "Part Number",
      field: "part_number",
      labelField: "part_number"
    },
    {
      label: "Cost",
    },
    {
      label: "Customer Charge"
    },
    {
      label: "Supplier",
      field: "supplier",
      labelField: "supplier__display_name"
    },
    {
      label: "Stock volume",
      field: "stock_volume",
      labelField: 'stock_volume'
    },
    {
      label: "Comments"
    },
  ];

  let params = {
    page,
    search,
  };

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter] || (filters[filter][0] && filters[filter][0][filter] === 0)) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const toggleSelectVisible = () => {
    let newSelected = { ...selected };
    let selectedKeys = Object.keys(newSelected);
    const notPresent = data.results.find(
      part => selectedKeys.indexOf(part.id.toString()) === -1
    );

    if (notPresent) {
      data.results.forEach(item => {
        newSelected[item.id.toString()] = item;
      });
    } else {
      data.results.forEach(item => {
        delete newSelected[item.id.toString()];
      });
    }
    setSelected(newSelected);
  };
  const onSelectCheck = item => {
    let newSelection = { ...selected };
    if (Object.keys(selected).indexOf(item.id.toString()) === -1) {
      newSelection[item.id.toString()] = item;
    } else {
      delete newSelection[item.id.toString()];
    }
    setSelected(newSelection);
  };

  const clearSelected = () => {
    setSelected({});
  };

  const updateMultiple = newData => {
    const url = props.endpoint + "partlookups";
    const conf = {
      method: "put",
      data: newData,
      url
    };

    return axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
      setSelected({});
    });
  };

  const saveSelected = (partName, partCost, partNumber, stockVolume) => {
    const newData = Object.values(selected).map(item => {
      let toSave = { ...item };
      if (partName) {
        toSave.name = partName;
      }
      if (partCost || partCost === 0) {
        toSave.cost = partCost;
      }
      if (partNumber) {
        toSave.part_number = partNumber;
      }
      if (stockVolume || stockVolume === 0) {
        toSave.stock_volume = stockVolume;
      }
      return toSave;
    });
    return updateMultiple(newData);
  };

  const complete = usePartLookupData(params, dataFresh);
  const makesLoaded = useVehicleMakeData({page_size:1000}, dataFresh);
  const modelsLoaded = useVehicleModelData({page_size:1000}, dataFresh);
  const data = useSelector(getPartLookupData);
  const makes = useSelector(getVehicleMakeData);
  const models = useSelector(getVehicleModelData);
  const vehicle_types = useSelector(getVehicleTypesData);

  const updateValue = (index, newPart) => {
    let currentData = { ...data };
    currentData.results[index] = newPart;
    dispatch(createSetPartLookupDataAction(currentData));
  };

  if (!complete || !vehicle_types_loaded || !makesLoaded || !modelsLoaded) return <div>Loading</div>;

  document.title = "Part Stock";
  const clear = e => {
    setSearch("");
    setSearchText("");
  }
  const handleSearch = e => {
    setPage(1);
    setSearch(searchText);
  }
  return (
    <div>
      <Box>
        <Columns>
          <Columns.Column>
            <Form.Label>Part Search</Form.Label>
            <SearchBar
              handleSearch={handleSearch}
              searchText={searchText}
              setSearchText={setSearchText}
              clear={clear}
              inputTestId={"part-search"}
              searchButtonTestId={"search-button"}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={() => setCreatePartModalOpen(true)}
                  color="success"
                  className="is-pulled-right"
                >
                  New Part +
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
      </Box>
      <Box>
        <Table>
          <thead>
            <tr>
              {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setPage(1);
                        setFilters(f);
                      }}
                      filters={filters}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                  />
                );
              })}
              <th>
                <Button
                  onClick={toggleSelectVisible}
                  color={
                    data.results.find(
                      part =>
                        Object.keys(selected).indexOf(part.id.toString()) === -1
                    )
                      ? ""
                      : "danger"
                  }
                >
                  {data.results.find(
                    part =>
                      Object.keys(selected).indexOf(part.id.toString()) === -1
                  ) ? (
                    <div>
                      <FAIcon size="small" icon={["fas", "check"]} />
                      <span>Visible</span>
                    </div>
                  ) : (
                    <div>
                      <FAIcon size="small" icon={["fas", "times"]} />
                      <span>Visible</span>
                    </div>
                  )}
                </Button>
              </th>
              {!!Object.entries(selected).length && (
                <th>
                  <Button onClick={() => setSelected({})} color="danger">
                    <FAIcon size="small" icon={["fas", "times"]} />
                  </Button>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.results.map((part, index) => (
              <PartLookupRow
                key={part.id}
                partLookup={part}
                endpoint={props.endpoint}
                updateValue={newPart => updateValue(index, newPart)}
                vehicleTypes={vehicle_types.results}
                onSelectCheck={onSelectCheck}
                selected={
                  Object.keys(selected).indexOf(part.id.toString()) !== -1
                }
                makes={makes}
                models={models}
              />
            ))}
          </tbody>
        </Table>
        <Pagination
          showFirstLast={true}
          onChange={setPage}
          current={page}
          total={Math.ceil(data.count / 25)}
        ></Pagination>
      </Box>
      <Box>
        <Columns>
          <Columns.Column>
            <Button
              fullwidth
              onClick={() => setEditModalOpen(true)}
              color={Object.entries(selected).length ? "primary" : ""}
              disabled={!Object.entries(selected).length}
            >
              Edit Selected
            </Button>
          </Columns.Column>
        </Columns>
      </Box>
      <MultiplePartStockEditModal
        open={editModalOpen}
        setOpen={setEditModalOpen}
        selected={selected}
        saveSelected={saveSelected}
      />
      <CreatePartModal
        open={createPartModalOpen}
        setOpen={setCreatePartModalOpen}
        endpoint={props.endpoint}
        vehicleTypes={vehicle_types.results}
        makes={makes}
        models={models}
      />
    </div>
  );
}

export default PartLookup;
